import { render, staticRenderFns } from "./TextMessageClient.vue?vue&type=template&id=0946bb10&scoped=true&lang=html"
import script from "./TextMessageClient.vue?vue&type=script&lang=js"
export * from "./TextMessageClient.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0946bb10",
  null
  
)

export default component.exports